// Single config module for the app. Env-driven values come from Vite's import.meta.env,
// which is populated at BUILD time from `.env.[mode]` (see .env.development / .env.production).
// Only VITE_-prefixed vars are exposed to client code by Vite — that is why every env key here
// is read as import.meta.env.VITE_*.

// Fail fast: if the API base URL wasn't baked in, every network call would silently hit the
// wrong origin. Better to crash loudly at startup than to ship a build pointed at nothing.
if (!import.meta.env.VITE_API_URL) {
  throw new Error("VITE_API_URL missing");
}

const keys = {
  SIGNUP_TOKEN: "SIGNUP_TOKEN_CP",
};
const stage_to_paths = {
  basic_profile: "/about-tenant",
};

export default {
  // Backend (cpcore) base URL — used by ~30 API call sites as config.API_URL.
  API_URL: import.meta.env.VITE_API_URL,
  LOCAL_KEYS: keys,
  OTP_LENGTH: 4,
  STAGE_TO_PATH: stage_to_paths,
  // PostHog project key. Property name intentionally kept as-is (config.posthhogkey) so the
  // existing call site in App.jsx keeps working — only the VALUE now comes from env.
  posthhogkey: import.meta.env.VITE_POSTHOG_KEY,
};
